import React from 'react';

export const ElectricitySvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={40}
      height={40}
      fill='none'
    >
      <rect
        width={40}
        height={40}
        fill='#fff'
        rx={20}
      />
      <path
        fill='#040325'
        fillRule='evenodd'
        d='M21.188 11.684a8.4 8.4 0 0 0-8.562 12.34l.205-.614a.6.6 0 0 1 1.138.38l-.6 1.8a.6.6 0 0 1-.759.38l-1.8-.6a.6.6 0 1 1 .38-1.14l.23.078a9.592 9.592 0 0 1-.923-5.666A9.6 9.6 0 0 1 24.89 11.74a.6.6 0 0 1-.611 1.032 8.4 8.4 0 0 0-3.092-1.088Zm5.443 2.726a.6.6 0 0 1 .759-.38l1.8.6a.6.6 0 1 1-.38 1.14l-.23-.078A9.599 9.599 0 0 1 22.382 29.3a9.598 9.598 0 0 1-7.274-1.04.6.6 0 1 1 .611-1.032 8.4 8.4 0 0 0 11.654-11.252l-.205.614a.6.6 0 0 1-1.138-.38l.6-1.8Zm-5.454-.37a.6.6 0 0 1 .383.56v3h3.24a.6.6 0 0 1 .469.975l-5.76 7.2a.6.6 0 0 1-1.069-.375v-3.9H15.2a.6.6 0 0 1-.443-1.005l5.76-6.3a.6.6 0 0 1 .66-.154Zm-4.615 6.26h2.478a.6.6 0 0 1 .6.6v2.79l3.912-4.89H20.96a.6.6 0 0 1-.6-.6v-2.055L16.562 20.3Z'
        clipRule='evenodd'
      />
    </svg>
  );
};
